module.exports = __webpack_public_path__ + "static/media/pe.3777e89e.svg";